import { render, staticRenderFns } from "./UiSegmented.vue?vue&type=template&id=70c3438f"
import script from "./UiSegmented.vue?vue&type=script&lang=js"
export * from "./UiSegmented.vue?vue&type=script&lang=js"
import style0 from "./UiSegmented.vue?vue&type=style&index=0&id=70c3438f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports